import { createApp } from 'vue/dist/vue.esm-bundler'
import BackgroundImage from '@/components/places/BackgroundImage.vue'
import LeafletMap from '@/components/LeafletMap.vue'
import PhotoList from '@/components/PhotoList.vue';
import MobilePrinter from '@/components/MobilePrinter.vue'
import LinkTo from '@/components/LinkTo.vue'
import App from '@/components/App.vue'

createApp(App)
  .component('background-image', BackgroundImage)
  .component('leaflet-map', LeafletMap)
  .component('photo-list', PhotoList)
  .component('mobile-printer', MobilePrinter)
  .component('link-to', LinkTo)
  .mount('#app')
